export default {"src":"/_next/static/media/setting-play.24cbaada.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};